const LIST_BRAND_VEHICLE = [
  {
    key: '',
    value: '',
    label: 'Merek Kendaraan',
  },
  {
    key: '1700',
    value: 'AUDI',
    label: 'AUDI',
  },
  {
    key: '1747',
    value: 'BIMANTARA',
    label: 'BIMANTARA',
  },
  {
    key: '1748',
    value: 'BMW',
    label: 'BMW',
  },
  {
    key: '1625',
    value: 'CHERY',
    label: 'CHERY',
  },
  {
    key: '1626',
    value: 'CHEVROLET',
    label: 'CHEVROLET',
  },
  {
    key: '1749',
    value: 'CHRYSLER',
    label: 'CHRYSLER',
  },
  {
    key: '2',
    value: 'DAIHATSU',
    label: 'DAIHATSU',
  },
  {
    key: '1627',
    value: 'DATSUN',
    label: 'DATSUN',
  },
  {
    key: '2077',
    value: 'DODGE',
    label: 'DODGE',
  },
  {
    key: '1628',
    value: 'DOOSAN',
    label: 'DOOSAN',
  },
  {
    key: '1629',
    value: 'FAW',
    label: 'FAW',
  },
  {
    key: '36',
    value: 'FORD',
    label: 'FORD',
  },
  {
    key: '2426',
    value: 'FOTON',
    label: 'FOTON',
  },
  {
    key: '1630',
    value: 'GEELY',
    label: 'GEELY',
  },
  {
    key: '2637',
    value: 'GOLDEN DRAGON',
    label: 'GOLDEN DRAGON',
  },
  {
    key: '1431',
    value: 'HINO',
    label: 'HINO',
  },
  {
    key: '1631',
    value: 'HITACHI',
    label: 'HITACHI',
  },
  {
    key: '5',
    value: 'HONDA',
    label: 'HONDA',
  },
  {
    key: '17',
    value: 'HYUNDAI',
    label: 'HYUNDAI',
  },
  {
    key: '2628',
    value: 'INFINITY',
    label: 'INFINITY',
  },
  {
    key: '4',
    value: 'ISUZU',
    label: 'ISUZU',
  },
  {
    key: '2660',
    value: 'JAGUAR',
    label: 'JAGUAR',
  },
  {
    key: '2971',
    value: 'JEEP',
    label: 'JEEP',
  },
  {
    key: '1632',
    value: 'KIA',
    label: 'KIA',
  },
  {
    key: '2482',
    value: 'LAMBORGHINI',
    label: 'LAMBORGHINI',
  },
  {
    key: '2355',
    value: 'LEXUS',
    label: 'LEXUS',
  },
  {
    key: '2013',
    value: 'MAN TGS',
    label: 'MAN TGS',
  },
  {
    key: '19',
    value: 'MAZDA',
    label: 'MAZDA',
  },
  {
    key: '3',
    value: 'MERCEDES BENZ',
    label: 'MERCEDES BENZ',
  },
  {
    key: '2289',
    value: 'MERCY',
    label: 'MERCY',
  },
  {
    key: '820',
    value: 'MITSUBISHI',
    label: 'MITSUBISHI',
  },
  {
    key: '1633',
    value: 'MORRIS',
    label: 'MORRIS',
  },
  {
    key: '18',
    value: 'NISSAN',
    label: 'NISSAN',
  },
  {
    key: '2073',
    value: 'OPEL',
    label: 'OPEL',
  },
  {
    key: '2026',
    value: 'PEUGEOT',
    label: 'PEUGEOT',
  },
  {
    key: '1634',
    value: 'PROTON',
    label: 'PROTON',
  },
  {
    key: '2193',
    value: 'SCANIA',
    label: 'SCANIA',
  },
  {
    key: '1635',
    value: 'SUBARU',
    label: 'SUBARU',
  },
  {
    key: '56',
    value: 'SUZUKI',
    label: 'SUZUKI',
  },
  {
    key: '2282',
    value: 'TATA',
    label: 'TATA',
  },
  {
    key: '1810',
    value: 'TIMOR',
    label: 'TIMOR',
  },
  {
    key: '1',
    value: 'TOYOTA',
    label: 'TOYOTA',
  },
  {
    key: '1636',
    value: 'UD TRUCK',
    label: 'UD TRUCK',
  },
  {
    key: '1995',
    value: 'VOLKSWAGEN',
    label: 'VOLKSWAGEN',
  },
  {
    key: '2206',
    value: 'VOLVO',
    label: 'VOLVO',
  },
]

export default LIST_BRAND_VEHICLE